import React, { useContext, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Footer from './Footer';

const Layout = ({ children, hideFooter = false }) => {
  const { user, logout, isChimney, isAdmin } = useContext(AuthContext);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate('/');
  };

  const linkClass = ({ isActive }) =>
    `text-sm font-medium transition ${isActive ? 'text-ember-600' : 'text-soot-700 hover:text-soot-950'}`;

  return (
    <div className="min-h-screen bg-soot-50 text-soot-900">
      <header className="sticky top-0 z-40 border-b border-soot-200/80 bg-soot-50/90 backdrop-blur-md">
        <div className="ik-container flex h-16 items-center justify-between gap-4 md:h-[4.5rem]">
          <Link to="/" className="flex items-center gap-3" onClick={() => setMenuOpen(false)}>
            <img
              src="/logo.png"
              alt="iKominiarz.pl"
              className="h-9 w-auto object-contain md:h-10"
            />
            <span className="font-display text-lg font-semibold tracking-tight text-soot-950 md:text-xl">
              iKominiarz
            </span>
          </Link>

          <nav className="hidden items-center gap-6 md:flex">
            <NavLink to="/chimneys" className={linkClass}>Kominiarze</NavLink>
            <NavLink to="/contact" className={linkClass}>Kontakt</NavLink>
            {user ? (
              <>
                {isAdmin() && <NavLink to="/admin-panel" className={linkClass}>Admin</NavLink>}
                {isChimney() ? (
                  <NavLink to="/chimney-dashboard" className={linkClass}>Panel</NavLink>
                ) : (
                  <NavLink to="/dashboard" className={linkClass}>Konto</NavLink>
                )}
                <NavLink to="/appointments" className={linkClass}>Wizyty</NavLink>
                <button
                  type="button"
                  onClick={handleLogout}
                  className="rounded-md border border-soot-300 px-3 py-1.5 text-sm font-medium text-soot-800 transition hover:border-soot-900"
                >
                  Wyloguj
                </button>
              </>
            ) : (
              <>
                <NavLink to="/register-chimney" className={linkClass}>Dla kominiarzy</NavLink>
                <NavLink to="/login" className={linkClass}>Zaloguj</NavLink>
                <Link to="/register" className="ik-btn-primary !px-4 !py-2 text-sm">
                  Załóż konto
                </Link>
              </>
            )}
          </nav>

          <button
            type="button"
            className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-soot-300 md:hidden"
            aria-label="Menu"
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span className="sr-only">Menu</span>
            <div className="space-y-1.5">
              <span className="block h-0.5 w-5 bg-soot-900" />
              <span className="block h-0.5 w-5 bg-soot-900" />
              <span className="block h-0.5 w-5 bg-soot-900" />
            </div>
          </button>
        </div>

        {menuOpen && (
          <div className="border-t border-soot-200 bg-soot-50 md:hidden">
            <div className="ik-container flex flex-col gap-3 py-4">
              <Link to="/chimneys" onClick={() => setMenuOpen(false)} className="py-1 font-medium">Kominiarze</Link>
              <Link to="/contact" onClick={() => setMenuOpen(false)} className="py-1 font-medium">Kontakt</Link>
              {user ? (
                <>
                  {isChimney() ? (
                    <Link to="/chimney-dashboard" onClick={() => setMenuOpen(false)} className="py-1 font-medium">Panel</Link>
                  ) : (
                    <Link to="/dashboard" onClick={() => setMenuOpen(false)} className="py-1 font-medium">Konto</Link>
                  )}
                  <Link to="/appointments" onClick={() => setMenuOpen(false)} className="py-1 font-medium">Wizyty</Link>
                  <button type="button" onClick={handleLogout} className="py-1 text-left font-medium text-ember-600">
                    Wyloguj
                  </button>
                </>
              ) : (
                <>
                  <Link to="/register-chimney" onClick={() => setMenuOpen(false)} className="py-1 font-medium">Dla kominiarzy</Link>
                  <Link to="/login" onClick={() => setMenuOpen(false)} className="py-1 font-medium">Zaloguj</Link>
                  <Link to="/register" onClick={() => setMenuOpen(false)} className="ik-btn-primary mt-2 text-center">
                    Załóż konto
                  </Link>
                </>
              )}
            </div>
          </div>
        )}
      </header>

      <main>{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
};

export default Layout;
